import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Transaccion } from 'src/app/dashboard/interfaces/transaccion.interface';
import { WorkingAccountService } from 'src/app/dashboard/services/working-account.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { TransaccionService } from 'src/app/dashboard/services/transaccion.service';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import Swal from 'sweetalert2';
import { FormBuilder, FormControl, FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { AcceptTransactionDTO } from 'src/app/dashboard/interfaces/accept-transaction.dto';
import { S3UrlService } from 'src/app/shared/services/s3-url.service';
@Component({
  selector: 'app-send-transaction-modal',
  templateUrl: './send-transaction-modal.component.html',
  styleUrls: ['./send-transaction-modal.component.sass']
})
export class SendTransactionModalComponent {
  datosForm: FormGroup | undefined;
  tiposID = ['CI', 'PASAPORTE', 'RUT'];
  transaction: Transaccion | undefined;
  contentType = 'image/jpeg';
  fileExt = 'jpeg';
  comprobante: any;
  constructor(
    private auth: CognitoService,
    private readonly transactionService: TransaccionService,
    private fb: UntypedFormBuilder,
    private spinner: SpinnerService, private workingAccountService: WorkingAccountService,
    public dialogRef: MatDialogRef<SendTransactionModalComponent>,
    private s3UrlService: S3UrlService,
    @Inject(MAT_DIALOG_DATA) public data: any ){
      //nombre del beneficiario, DNI, Numero de cuenta.
      // public dialogRef: MatDialogRef<EditTransactionModalComponent>,
    //@Inject(MAT_DIALOG_DATA) public data: any
     this.transaction = data;
     this.initForm();
  }

  initForm(){
    this.datosForm = this.fb.group({
      // Referencia es REQUIRED — se usa como nombre del archivo del
      // comprobante en S3 (`comprobantes/<cognitoIdCliente>/<referencia>.<ext>`).
      // Sin referencia no se puede subir el archivo con un nombre legible.
      referencia: new FormControl('', [Validators.required]),
      photo: []
    });
  }

  setFileData(event: Event): void {
    const eventTarget: HTMLInputElement | null = event.target as HTMLInputElement | null;
    if (eventTarget?.files?.[0]) {
      const file: File = eventTarget.files[0];
      this.contentType = file.type;
      const filename = file.name;
      this.fileExt = filename.split('.').pop() || '';
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.datosForm?.get('photo')?.setValue(reader.result as string);
      });

      reader.readAsDataURL(file);
    }
  }

  /**
   * Post-VULN-01: el backend firma la upload URL, el browser hace PUT
   * directo a S3. El archivo queda como:
   *
   *    comprobantes/<referenciaSanitizada>.<ext>
   *
   * `comprobantes/` es un folder COMPARTIDO (no por usuario) — la
   * vinculación archivo↔cliente queda en BD vía `transaccion.comprobante`.
   * El JWT del operador autoriza la operación; la auditoría de "quién
   * subió" vive en logs backend + CloudTrail, no en el path.
   *
   * El nombre del archivo es exactamente la referencia que el operador
   * tipea en el form (sanitizada para chars seguros). Si dos
   * transacciones usan la misma referencia, la segunda sobrescribe a
   * la primera — S3 versioning del bucket preserva el histórico.
   */
  async uploadBase64Image(base64Image: string): Promise<void> {
    const referencia = (this.datosForm?.get('referencia')?.value as string ?? '').trim();
    if (!referencia) {
      throw new Error('La referencia es requerida para subir comprobante');
    }
    const safeRef = referencia.replace(/[^a-zA-Z0-9_-]/g, '_');
    const suggestedName = `${safeRef}.${this.fileExt}`;

    const cleanedBase64 = base64Image.replace(/^data:image\/\w+;base64,/, '');
    const binary = atob(cleanedBase64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    const blob = new Blob([bytes], { type: this.contentType });

    const { url, key } = await this.s3UrlService.getUploadUrl(
      this.contentType,
      'comprobante',
      suggestedName,
    );

    const putRes = await fetch(url, {
      method: 'PUT',
      headers: { 'Content-Type': this.contentType },
      body: blob,
    });
    if (!putRes.ok) {
      throw new Error(`S3 upload failed con HTTP ${putRes.status}`);
    }
    this.comprobante = key;
  }

  async acceptTransaction(){
    if(this.datosForm?.invalid || !this.transaction?.id)return;
    const spinnerRef = this.spinner.start();
    const payload: AcceptTransactionDTO = {
      transactionID: this.transaction?.id,
      referencia: this.datosForm?.get('referencia')?.value,
      precioCompra: this.transaction.precio_compra,
    }
    try{
      if(this.datosForm?.get('photo')?.value){
        await this.uploadBase64Image(this.datosForm?.get('photo')?.value);
        payload.comprobante = this.comprobante;
      }
      await this.transactionService.acceptTransaction(payload);

      Swal.fire({
        icon: 'success',
        title: 'Transacción pagada',
        text: 'la transacción se ha pagado exitosamente',
        showCancelButton: false,
        showDenyButton: false,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#1e5a3f',

      });
      this.dialogRef.close(true);
    }catch(error: any){
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.error.mensaje,
        showCancelButton: false,
        showDenyButton: false,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#1e5a3f',

      });
      this.dialogRef.close(true);
    }

    this.spinner.stop(spinnerRef);
  }

  close(){
    this.dialogRef.close();
  }
}
